export default "__VITE_ASSET__466bcc3c__"